import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { useOptionalAuth } from '@cash-web/shared-auth-data-access-context'
import { useCountryFromRegionProvider } from '@cash-web/shared-data-access-region-provider'

export const useCurrencySymbol = () => {
  const auth = useOptionalAuth()
  const unreliableCountryCode = useCountryFromRegionProvider()

  const countryCode = auth === undefined ? unreliableCountryCode : auth.profile?.country_code

  return countryCode === Country.GB ? '£' : '$'
}
